import { render, staticRenderFns } from "./PortSearchWidget.vue?vue&type=template&id=71b87d26&scoped=true&"
import script from "./PortSearchWidget.vue?vue&type=script&lang=js&"
export * from "./PortSearchWidget.vue?vue&type=script&lang=js&"
import style0 from "./PortSearchWidget.vue?vue&type=style&index=0&id=71b87d26&scoped=true&lang=css&"
import style1 from "./PortSearchWidget.vue?vue&type=style&index=1&id=71b87d26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b87d26",
  null
  
)

export default component.exports